/**
 * Created by wiki on 2017/3/17.
 */
import config from './config'
import http from './http'

export default {
  bgmLogin:{
    login(param, success, error){
      config.url = 'sys';
      http.post(param, config, success, error);
    },
  },


  login:function (param, success, error) {
    config.url = 'sys/login';
    http.post(param, config, success, error);
  },
  currDept:function (param, success, error) {
    config.url = 'sys/'+param;
    http.get(param, config, success, error);
  },
  // gatewaytype:function (param, success, error) {
  //   config.url = 'sys/gateway_type';
  //   http.get(param, config, success, error);
  // },
  // gatewayversion:function (param, success, error) {
  //   config.url = 'sys/gateway_version';
  //   http.get(param, config, success, error);
  // },

  // node_type:function (param, success, error) {
  //   config.url = 'sys/node_type';
  //   http.get(param, config, success, error);
  // },
  // ------------------- 系统管理start -----------------------
  // 库存管理`
  kucun:function (param, success, error) {
    config.url = 'sys/'+param;
    http.post(param, config, success, error);
  },
  // 管理官管理
  User:{
    getLists(param, success, error){
      config.url = 'sys/user/list';
      http.get(param, config, success, error);
    },
    addAdmin(param, success, error){
      config.url = 'sys/user/save';
      http.post(param, config, success, error);
    },
    delAdmin(param, success, error){
      config.url = 'sys/user/delete';
      http.post(param, config, success, error);

    },
    updateAdmin(param, success, error){
      config.url = 'sys/user/update';
      http.post(param, config, success, error);

    },
    password(param, success, error){
      config.url = 'sys/user/password';
      http.post(param, config, success, error);

    }
  },
  // 组织架构管理
  Dept:{
    getLists(param, success, error){
      config.url = 'sys/dept/tree';
      http.get(param, config, success, error);
    },
    getData(param, success, error){
      config.url = 'sys/dept/nav';
      http.get(param, config, success, error);
    },
    treeList(param, success, error){
      config.url = 'sys/dept/nav';
      http.get(param, config, success, error);
    },
    addDept(param, success, error){
      config.url = 'sys/dept/save';
      http.post(param, config, success, error);
    },
    delDept(param, success, error){
      config.url = 'sys/dept/delete/'+param.deptId+'/';
      http.post(param, config, success, error);
    },
    updateDept(param, success, error){
      config.url = 'sys/dept/update';
      http.post(param, config, success, error);
    },
    getType(param, success, error){
      config.url = 'sys/dict/select/' + param.type;
      http.get(param, config, success, error);
    }
  },
  // 角色管理
  Role:{
    getLists(param, success, error){
      config.url = 'sys/role/select';
      http.get(param, config, success, error);
    },
    roleLists(param, success, error){
      config.url = 'sys/role/all';
      http.get(param, config, success, error);
    },
    keyLists(param, success, error){
      config.url = 'sys/role/list';
      http.get(param, config, success, error);
    },
    // 新增的menu list
    addRole(param, success, error){
      config.url = 'sys/role/save';
      http.post(param, config, success, error);
    },
    updateRole(param, success, error){
      config.url = 'sys/role/update';
      http.post(param, config, success, error);
    },
    delRole(param, success, error){
      config.url = 'sys/role/delete';
      http.post(param, config, success, error);
    },

  },
  // 菜单管理
  Menu:{
    getLists(param, success, error){
      config.url = 'sys/menu/nav';
      http.get(param, config, success, error);
    },
    getTree(param, success, error){
      config.url = 'sys/menu/tree';
      http.get(param, config, success, error);
    },
  },
  // 字典管理
  Dict:{
    getList(param, success, error){
      config.url='dict/list';
      http.get(param, config, success, error)
    },
    addDict(param, success, error){
      config.url='dict/save';
      http.post(param, config, success, error)
    },
    deleteDict(param, success, error){
      config.url='dict/delete';
      http.post(param, config, success, error)
    },
    updateDict(param, success, error){
      config.url='dict/update';
      http.post(param, config, success, error)
    },
  },
  // 系统日志
  sysLog: {
    getLists(param, success, error){
      config.url = 'sys/log/list';
      http.get(param, config, success, error);
    }
  },
 // 定时任务
  timing: {
    getLists(param, success, error){
      config.url = 'sys/schedule/list';
      http.get(param, config, success, error);
    },
    save(param, success, error){
      config.url = 'sys/schedule/save';
      http.post(param, config, success, error);
    },
    update(param, success, error){
      config.url = 'sys/schedule/update';
      http.post(param, config, success, error);
    },
    delete(param, success, error){
      config.url = 'sys/schedule/delete';
      http.post(param, config, success, error);
    },
    pause(param, success, error){
      config.url = 'sys/schedule/pause';
      http.post(param, config, success, error);
    },
    resume(param, success, error){
      config.url = 'sys/schedule/resume';
      http.post(param, config, success, error);
    },
    run(param, success, error){
      config.url = 'sys/schedule/run';
      http.post(param, config, success, error);
    }
  },

  // 定时任务日志
  timingLog: {
    getLists(param, success, error){
      config.url = 'sys/scheduleLog/list';
      http.get(param, config, success, error);
    },
    getListsItem(param, success, error){
      var logId = param.logId;
      param = {};
      config.url = 'sys/scheduleLog/info/' + logId;
      http.get(param, config, success, error);
    }
  },

 // 参数管理
  parameter: {
    getLists(param, success, error){
      config.url = 'sys/config/list';
      http.get(param, config, success, error);
    },
    save(param, success, error){
      config.url = 'sys/config/save';
      http.post(param, config, success, error);
    },
    update(param, success, error){
      config.url = 'sys/config/update';
      http.post(param, config, success, error);
    },
    delete(param, success, error){
      config.url = 'sys/config/delete';
      http.post(param, config, success, error);
    }
  },
 // ------------------- 系统管理end -----------------------

// ------------------- 采购业务start -----------------------





// ------------------- 采购业务end -------------------------

// ------------------- 基础信息start -------------------------
warehouse:{
  getTree(param, success, error){
    config.url = 'base/warehouse/list';
    http.get(param, config, success, error);
  },
  whList(param, success, error){
    config.url = 'base/warehouse/list';
    http.get(param, config, success, error);
  },
},
//销售
contract:{
  getList(param, success, error){
    config.url = 'base/accrual/list';
    http.get(param, config, success, error);
  },
  delContract(param, success, error){
    config.url = 'base/accrual/delete';
    http.post(param, config, success, error);
  },
  addContract(param, success, error){
    config.url = 'base/accrual/save';
    http.post(param, config, success, error);
  },
  editContract(param, success, error){
    config.url = 'base/accrual/update';
    http.post(param, config, success, error);
  },
  rateType(param, success, error){
    config.url = 'sys/dict/select/'+param;
    http.get(param, config, success, error);
  }
},
//包装方式
packType:{
  getList(param, success, error){
    config.url = 'base/packingType/list';
    http.get(param, config, success, error);
  },
  addPack(param, success, error){
    config.url = 'base/packingType/save';
    http.post(param, config, success, error);
  },
  editPack(param, success, error){
    config.url = 'base/packingType/update';
    http.post(param, config, success, error);
  },
  delPack(param, success, error){
    config.url = 'base/packingType/delete';
    http.post(param, config, success, error);
  }
},
//缺陷代码维护
bug:{
  getList(param, success, error){
    config.url = 'base/bugDesc/list';
    http.get(param, config, success, error);
  },
  addBug(param, success, error){
    config.url = '/base/bugDesc/save';
    http.post(param, config, success, error);
  },
  editBug(param, success, error){
    config.url = '/base/bugDesc/update';
    http.post(param, config, success, error);
  },
  delBug(param, success, error){
    config.url = '/base/bugDesc/delete';
    http.post(param, config, success, error);
  },
  bugDesc(param, success, error){
    config.url = '/base/bugDesc/info/'+param;
    http.get(param, config, success, error);
  },
  bugType(param, success, error){
    config.url = '/sys/dict/select/'+param;
    http.get(param, config, success, error);
  }
},
//站点
site:{
  getList(param, success, error){
    config.url = '/base/stationsite/list';
    http.get(param, config, success, error);
  },
  addSite(param, success, error){
    config.url = '/base/stationsite/save';
    http.post(param, config, success, error);
  },
  editSite(param, success, error){
    config.url = '/base/stationsite/update';
    http.post(param, config, success, error);
  },
  delSite(param, success, error){
    config.url = '/base/stationsite/delete';
    http.post(param, config, success, error);
  }
},
//供应商
supplier:{
  getList(param, success, error){
    config.url = '/base/logistics/dlvSite/list';
    http.get(param, config, success, error);
  },
  addSupplier(param, success, error){
    config.url = '/base/logistics/dlvSite/save';
    http.post(param, config, success, error);
  },
  editSupplier(param, success, error){
    config.url = '/base/logistics/dlvSite/update';
    http.post(param, config, success, error);
  },
  delSupplier(param, success, error){
    config.url = '/base/logistics/dlvSite/delete';
    http.post(param, config, success, error);
  }
},
// 仓库库区
warehouse:{
  getTree(param, success, error){
    config.url = 'base/warehouse/list';
    http.get(param, config, success, error);
  },
  whList(param, success, error){
    config.url = 'base/warehouse/list';
    http.get(param, config, success, error);
  },
  addWarehouse(param, success, error){
    config.url = 'base/warehouse/save';
    http.post(param, config, success, error);
  },
  delWarehouse(param, success, error){
    console.log(param)
    config.url = 'base/warehouse/delete/' + param;
    http.post(param, config, success, error);
  },
  updateWarehouse(param, success, error){
    config.url = 'base/warehouse/update';
    http.post(param, config, success, error);
  },
  // 仓库信息
  whInfo(param, success, error){
    // var id = param.curId;
    config.url = 'base/warehouse/info/'+ param;
    http.get(param, config, success, error);
  },
  // 库区信息
  storageInfo(param, success, error){
    config.url = 'base/storagearea/info/' + param;
    http.get(param, config, success, error);
  },
  storageLists(param, success, error){
    config.url = 'base/storagearea/list';
    http.get(param, config, success, error);
  },
  addStorage(param, success, error){
    config.url = 'base/storagearea/save';
    http.post(param, config, success, error);
  },
  delStorage(param, success, error){
    var id = param.delId;
    config.url = 'base/storagearea/delete/' + id;
    http.post(param, config, success, error);
  },
  updateStorage(param, success, error){
    config.url = 'base/storagearea/update';
    http.post(param, config, success, error);
  },
  // 库位
  locationLists(param, success, error){
    config.url = 'base/storagelocation/list';
    http.get(param, config, success, error);
  },
  addLocation(param, success, error){
    config.url = 'base/storagelocation/save';
    http.post(param, config, success, error);
  },
  delLocation(param, success, error){
    var id = param.delId;
    config.url = 'base/storagelocation/delete';
    http.post(param, config, success, error);
  },
  updateLocation(param, success, error){
    config.url = 'base/storagelocation/update';
    http.post(param, config, success, error);
  },

},
// 币种管理
Currency: {
  getLists(param, success, error){
    config.url = 'base/currency/list';
    http.get(param, config, success, error);
  },
  addCurrency(param, success, error){
    config.url = '/base/currency/save';
    http.post(param, config, success, error);
  },
  update(param, success, error){
    config.url = '/base/currency/update';
    http.post(param, config, success, error);
  },
  delete(param, success, error){
    config.url = '/base/currency/delete';
    http.post(param, config, success, error);
  },
},
// 品种管理
Product: {
  getLists(param, success, error){
    config.url = '/base/productType/list';
    http.get(param, config, success, error);
  },
  addCurrency(param, success, error){
    config.url = '/base/productType/save';
    http.post(param, config, success, error);
  },
  update(param, success, error){
    config.url = '/base/productType/update';
    http.post(param, config, success, error);
  },
  delete(param, success, error){
    console.log(param)
    config.url = '/base/productType/delete/'+param;
    http.post(param, config, success, error);
  },
},
// 品种牌号
Sign: {
  getLists(param, success, error){
    config.url = '/base/productTypeShopsign/list';
    http.get(param, config, success, error);
  },
  addCurrency(param, success, error){
    config.url = '/base/productTypeShopsign/save';
    http.post(param, config, success, error);
  },
  update(param, success, error){
    config.url = '/base/productTypeShopsign/update';
    http.post(param, config, success, error);
  },
  delete(param, success, error){
    config.url = '/base/productTypeShopsign/delete';
    http.post(param, config, success, error);
  },
},
// ------------------- 基础信息end -------------------------

}





// WEBPACK FOOTER //
// ./src/api/apinew.js